export const resizeImageFile = (file, options = { MAX_WIDTH: 1024, MAX_HEIGHT: 1024 }) =>
  new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('empty image file to resize'));
    }
    const { MAX_WIDTH, MAX_HEIGHT } = options;

    const reader = new FileReader();
    reader.onload = e => {
      const img = new Image();
      img.src = e.target.result;

      // resize on image file loaded
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);

        let { width, height } = img;

        // keep aspect ratio
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
        canvas.width = width;
        canvas.height = height;
        ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        const dataurl = canvas.toDataURL('image/png');
        resolve(dataurl);
      };
    };
    reader.readAsDataURL(file);
  });

export const preloadImage = images => {
  images.forEach(image => {
    const img = new Image();
    img.src = image;
  });
};
